export default "__VITE_ASSET__BgBgNtu6__"